import { Textarea } from '@/components/ui/textarea';
import { AlertCircle, CheckCircle2 } from 'lucide-react';
import { cn } from '@/lib/utils';

interface ObservationsCardProps {
  summary: string;
  status: string;
  onSummaryChange?: (v: string) => void;
}

export function ObservationsCard({ summary, status, onSummaryChange }: ObservationsCardProps) {
  const isFlagged = status === 'flagged';
  return (
    <div
      className={cn(
        'border border-border-strong/70 border-l-4 bg-card p-6 shadow-[0_12px_28px_-22px_rgba(29,43,34,0.5)] sm:p-8',
        isFlagged ? 'border-l-clay' : 'border-l-pine',
      )}
    >
      <div className="flex items-start gap-4">
        <div
          className={cn(
            'mt-1 shrink-0 rounded-sm border-2 p-2.5',
            isFlagged
              ? 'border-ring/40 text-ring'
              : 'border-sidebar-primary/40 text-sidebar-primary',
          )}
        >
          {isFlagged ? <AlertCircle className="size-5" /> : <CheckCircle2 className="size-5" />}
        </div>
        <div className="flex-1 space-y-2">
          <h3 className="font-display text-xl font-medium leading-tight text-foreground">
            Inspector Observations
          </h3>
          {onSummaryChange ? (
            <>
              <Textarea
                className="min-h-[80px] rounded-sm border-border bg-background text-base leading-relaxed text-foreground/80"
                value={summary}
                onChange={(e) => onSummaryChange(e.target.value)}
              />
              <p className="text-xs text-foreground/50">
                You can edit this summary before approving or rejecting.
              </p>
            </>
          ) : (
            <p className="text-base leading-relaxed text-foreground/70">{summary}</p>
          )}
        </div>
      </div>
    </div>
  );
}
